namespace Account
{

	export class Page
		extends ui.tab.TabHTMLPresentation
	{

		private m_Account: Wollmilch.AccountObject;

		constructor( Account: Wollmilch.AccountObject )
		{
			super();

			this.m_Account = Account;

			this.Display();
		}

		public Display(): void
		{
			this.m_Root	= ui.$$.div().addClass( 'container-fluid' );

			const left = ui.$$.div().addClass( 'col-xs-12' ).addClass( 'col-sm-6' );
			const right = ui.$$.div().addClass( 'col-xs-12' ).addClass( 'col-sm-6' );

			this.m_Root.append( ui.$$.div().addClass( 'row' ).append( left ).append( right ) );

			left.append( ui.$$.pre().append( ui.json.Highlight( JSON.stringify( this.m_Account, undefined, 2 ) ) ) );

			const editform = new Form( { tag: 'div', orientation: 'horizontal' } );
			const inputGroup = editform.newFormGroup( [ 1 ] );

			inputGroup.addItem(
				{
					label: new InputLabel( { value: 'Username' } ),
					input: new InputText( { name: 'Username', value: this.m_Account.Username, classes: ['form-control'] } )
				} );
			right.append( editform.getElement() );
			right.append( ui.$$.br() );

			// Status-Button
			let btn_active;
			let label_active;
			if ( this.m_Account.Status.Active )
			{
				label_active = new InputLabel({value: ' aktiv ', classes: ['status_okay']}).getElement();
				btn_active = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click:  ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setInactiveStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			else
			{
				label_active = new InputLabel({value: ' in-aktiv ', classes: ['status_becareful']}).getElement();
				btn_active = new Button(
					{
						title: 'change',
						block: false,
						size: 'xs',
						on:
						{
							click:  () =>
							{
								return function()
								{
									const account2 = new clStatus( this.Account );

									account2.setActiveStatus();
								};
							}
						}
					}
				).getElement();
			}
			right.append( btn_active );
			right.append( label_active );
			right.append( ui.$$.br() );

			let btn_visible;
			let label_visible;
			if ( this.m_Account.Status.Visible )
			{
				label_visible = new InputLabel({value: ' sichtbar ', classes: ['status_okay']}).getElement();
				btn_visible = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click:  ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setInvisibleStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			else
			{
				label_visible = new InputLabel({value: ' unsichtbar ', classes: ['status_becareful']}).getElement();
				btn_visible = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click:  ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setVisibleStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			right.append( btn_visible );
			right.append( label_visible );
			right.append( ui.$$.br() );

			let btn_locked;
			let label_locked;
			if ( this.m_Account.Status.Locked )
			{
				label_locked = new InputLabel({value: ' gesperrt ', classes: ['status_becareful']}).getElement();
				btn_locked = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click:  ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setUnlockStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			else
			{
				label_locked = new InputLabel({value: ' frei ', classes: ['status_okay']}).getElement();
				btn_locked = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click:  ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setLockedStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			right.append( $( btn_locked ) );
			right.append( $( label_locked ) );
			right.append( ui.$$.br() );

			let btn_deleted;
			let label_deleted;
			if ( this.m_Account.Status.Deleted )
			{
				label_deleted = new InputLabel({value: ' gelöscht ', classes: ['status_becareful']}).getElement();
				btn_deleted = new Button(
					{
						title: 'change',
						block: false,
						size: 'xs',
						on:
						{
							click:  () =>
							{
								return function()
								{
									const account2 = new clStatus( this.Account );

									account2.setUndeleteStatus();
								};
							}
						}
					}
				).getElement();
			}
			else
			{
				label_deleted = new InputLabel({value: ' nicht gelöscht ', classes: ['status_okay']}).getElement();
				btn_deleted = new Button( { title: 'change', block: false, size: 'xs',
						on:
							{	click: ( ( _item_ ) =>
								{return function()
									{
										const account2 = new clStatus( _item_ );
										account2.setDeleteStatus();
									};
								})( this.m_Account )
							}
						} ).getElement();
			}
			right.append( $( btn_deleted ) );
			right.append( $( label_deleted ) );
			right.append( ui.$$.br() );

			right.append( ui.$$.p().text( 'angelegt am: ' ) );
			right.append( new Date( this.m_Account.CreatedAt || '0' ).pattern('d.m.Y H:i:s') );
			right.append( ui.$$.br() );
			right.append( ui.$$.p().text( 'aktualisiert am: ') );
			
			if ( this.m_Account.LastEdited )
			{
				right.append( new Date ( this.m_Account.LastEdited ).pattern('d.m.Y H:i:s') );
			}
		}

	}

}
